export default __webpack_public_path__ + "static/52299-ea817f320d04dac5eb3bb69b1866a023.jpg";